import { render, staticRenderFns } from "./questionGroup.vue?vue&type=template&id=9bc7fcba&scoped=true&"
import script from "./questionGroup.vue?vue&type=script&lang=ts&"
export * from "./questionGroup.vue?vue&type=script&lang=ts&"
import style0 from "./questionGroup.vue?vue&type=style&index=0&id=9bc7fcba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc7fcba",
  null
  
)

export default component.exports